import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Popconfirm,
  Row,
  Select,
  Drawer,
  TreeSelect,
  Table,
  Divider,
  Checkbox,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetDataExam } from "app/Reducers/examSlice";
import {
  delSubmitSetExamURL,
  postSubmitSetExamURL,
  putSubmitSetExamURL,
} from "api/ismsApi";
import moment from "moment";
import {
  openNotificationWithIcon,
  return_filter_team,
  errorHandle,
} from "containers/Function";
import "../ViewExam.css";
import { postDownloadExamApi } from "api/getResultExam";
import fnFileDownload from "js-file-download";
import { QuestionCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { ListBoPhanApi } from "api/getListTeam";
import { GetGroupISMSUserApi } from "api/getGroup";

const getColumns = ({
  allSelected,
  someSelected,
  selectedRowKeys,
  form,
  toggleSelectRow,
  toggleSelectAll,
}) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    align: "center",
    render: (value, item, index) => index + 1,
    width: 60,
  },
  {
    title: "Nhân viên",
    dataIndex: "username",
    key: "username",
    filterKey: "username",
    type: "text",
    width: 150,
    render: (text, record) => record.msnv + "-" + text,
  },
  {
    title: "Họ và tên",
    dataIndex: "username",
    key: "username",
    filterKey: "username",
    type: "text",
    width: 190,
    render: (text, record) => record.last_name + " " + record.first_name,
  },
  {
    title: "Team",
    dataIndex: "fore_team__tenTeam",
    render: (text) => text || "",
    width: 70,
  },
  {
    title: "Nhóm thi",
    dataIndex: "data_group_isms",
    key: "data_group_isms",
    filterKey: "data_group_isms",
    type: "text",
    render: (item, record) => (
      // item.map((group, index) => {
      //   if (group.id === form.getFieldValue("loai_cau_hoi")) {
      //     return <div key={index}>{group.note}</div>;
      //   }
      // }),
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          maxHeight: "300px",
          overflowY: "auto",
        }}
      >
        {item.map((group, index) => (
          <div key={index}>🔹 {group.note}</div>
        ))}
      </div>
    ),
  },
  {
    title: (
      <Checkbox
        checked={allSelected}
        indeterminate={someSelected}
        onChange={toggleSelectAll}
      />
    ),
    className: "highlight",
    key: "select",
    fixed: "right",
    type: "text",
    align: "center",
    width: 60,
    render: (text, record) =>
      getBtnAction({
        record,
        selectedRowKeys,
        toggleSelectRow,
      }),
    canSearch: true,
  },
];

const getBtnAction = ({
  record,
  selectedRowKeys,
  toggleSelectRow,
}) => {
  const isChecked = selectedRowKeys.includes(record.id);

  return (
    <>
      <Row>
        <Col span={24}>
          <div style={{ textAlign: "center" }}>
            <Checkbox
              checked={selectedRowKeys && isChecked}
              onChange={() => toggleSelectRow(record.id)}
            />
          </div>
        </Col>
      </Row>
    </>
  );
};

const ViemUpdateExam = ({ fetchDataSetExam }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const showDrawer = () => setIsDrawerOpen(true);
  const closeDrawer = () => setIsDrawerOpen(false);
  const { isCheckOpenModal, valueTypeQuestion, dataExamDetail } = useSelector(
    (state) => state.exam
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const selectedGroup = useRef(null);
  const [teamsSelected, setTeamsSelected] = useState([]);
  const [usersSelected, setUsersSelected] = useState([]);

  const userInfo = useSelector((state) => state?.getUserInfo.userInfo);

  const allSelected =
    selectedRowKeys &&
    data &&
    selectedRowKeys.length === data.length &&
    data.length > 0;
  const someSelected =
    selectedRowKeys && selectedRowKeys.length > 0 && !allSelected;

  const submitCreateSetExam = (e) => {
    if ([undefined].includes(e.loai_cau_hoi) || currentTeam.length === 0) {
      openNotificationWithIcon(
        "error",
        "Vui lòng chọn danh sách tham gia đợt thi"
      );
      return false;
    }

    if (teamsSelected.length === 0 && usersSelected.length === 0) {
      openNotificationWithIcon(
        "error",
        "Vui lòng thêm nhân viên tham gia đợt thi"
      );
      return false;
    }

    postSubmitSetExamURL({
      ma_de_thi: e.ma_de_thi,
      loai_cau_hoi: e.loai_cau_hoi,
      so_luong_cau_hoi: e.so_luong_cau_hoi,
      so_cau_dat: e.so_cau_dat,
      thoi_gian_thi: e.thoi_gian_thi,
      ngay_bat_dau: moment(e.ngay_bat_dau).format("DD/MM/YYYY"),
      ngay_ket_thuc: moment(e.ngay_ket_thuc).format("DD/MM/YYYY"),
      so_lan_duoc_thi: e.so_lan_duoc_thi,
      nguoi_tao: userInfo.username,
      teamsSelected: teamsSelected,
      usersSelected: usersSelected,
    })
      .then((res) => {
        handleCancelExam();
        fetchDataSetExam();
        openNotificationWithIcon("success", "Tạo đợt thi thành công");
      })
      .catch((error) => {
        console.log(error.data.error);
        openNotificationWithIcon("error", error.data.error);
      });
  };

  const submitUpdateSetExam = (e) => {

    putSubmitSetExamURL({
      ma_de_thi: e.ma_de_thi,
      loai_cau_hoi: e.loai_cau_hoi,
      so_luong_cau_hoi: e.so_luong_cau_hoi,
      so_cau_dat: e.so_cau_dat,
      thoi_gian_thi: e.thoi_gian_thi,
      ngay_bat_dau: moment(e.ngay_bat_dau).format("DD/MM/YYYY"),
      ngay_ket_thuc: moment(e.ngay_ket_thuc).format("DD/MM/YYYY"),
      so_lan_duoc_thi: e.so_lan_duoc_thi,
      nguoi_tao: userInfo.username,
      id: dataExamDetail.id,
      teamsSelected: teamsSelected,
      usersSelected: usersSelected,
    })
      .then((res) => {
        handleCancelExam();
        fetchDataSetExam();
        openNotificationWithIcon("success", "Cập nhật đợt thi thành công");
      })
      .catch((error) => {
        console.log(error.data.error);
        openNotificationWithIcon("error", error.data.error);
      });
  };

  const submitDeleteExam = (e) => {
    delSubmitSetExamURL({
      id: dataExamDetail.id,
    })
      .then((res) => {
        handleCancelExam();
        fetchDataSetExam();
        openNotificationWithIcon("success", "Xóa đợt thi thành công");
      })
      .catch((error) => {
        console.log(error.data.error);
        openNotificationWithIcon("error", error.data.error);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      if (res.data.length > 0) {
        var data_curr_bp = res.data.filter((x) => x.team.length !== 0);
        // setCurrentBoPhan([data_curr_bp[0].id]);
        setLsBoPhan(data_curr_bp);

        // if (currentTeam.length === 0) {
        //   var data_curr_team = data_curr_bp[0].team[0];
        //   setCurrentTeam([data_curr_team.id]);
        // }
      }

      var uniqueArrTeam = return_filter_team([data_curr_bp[0]]);
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });

      setLsTeam(uniqueArrTeam);
    });
  };

  const fetchDataUser = (params = {}) => {
    setLoading(true);
    GetGroupISMSUserApi(params)
      .then((res) => {
        setData(res.data.results);
        selectedGroup.current = form.getFieldValue("loai_cau_hoi");
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchListTeam();
  }, []);

  const handleCancelExam = () => {
    dispatch(resetDataExam());
    form.resetFields();
  };

  const handleDeleteExam = () => {
    handleCancelExam();
    submitDeleteExam();
  };

  const onFinish = (e) => {
    if (!!dataExamDetail) {
      submitUpdateSetExam(e);
    } else {
      submitCreateSetExam(e);
    }
  };

  const fileDownloadExam = () => {
    // setLoading(true);
    var filename =
      dataExamDetail.ma_de_thi + "_" + moment().format("DDMMYYYY") + ".docx";

    postDownloadExamApi({
      id_set_exam: dataExamDetail.id,
    })
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        fnFileDownload(blob, filename);
        // setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        openNotificationWithIcon(
          "error",
          "Không tải được đợt thi. Bạn vui lòng thử lại."
        );
        // setLoading(false);
      });
  };

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = return_filter_team(
        lsBoPhan.filter((x) => value.includes(x.id))
      );
      lsTeamWith_BP.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });
      var getCurTeam = lsTeamWith_BP.map((item) => item.idTeam)[0];

      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([getCurTeam]);
      form.setFieldsValue({
        bophan: value,
        team: [getCurTeam],
      });
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
      form.setFieldsValue({
        team: [],
        bophan: [],
      });
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan([]);
      form.setFieldsValue({
        team: [],
      });
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
      form.setFieldsValue({
        team: value,
      });
    } else {
      setCurrentTeam([]);
      form.setFieldsValue({
        team: [],
      });
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeTeam([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeTeam(lsTeam.map((item) => item.idTeam));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  // useEffect(() => {
  //   if (currentTeam.length > 0) {
  //     fetchDataUser({ idTeam: JSON.stringify(currentTeam) });
  //   }
  //   if (currentTeam.length === 0) {
  //     setData([]);
  //   }
  // }, [currentTeam]);

  useEffect(() => {
    if (dataExamDetail !== undefined && isCheckOpenModal === true) {
      form.setFieldsValue({
        ma_de_thi: dataExamDetail.ma_de_thi,
        loai_cau_hoi: dataExamDetail.loai_cau_hoi.id,
        so_luong_cau_hoi: dataExamDetail.so_luong_cau_hoi,
        so_cau_dat: dataExamDetail.so_cau_dat,
        thoi_gian_thi: dataExamDetail.thoi_gian_thi,
        ngay_bat_dau: moment(dataExamDetail.ngay_bat_dau, "DD/MM/YYYY"),
        ngay_ket_thuc: moment(dataExamDetail.ngay_ket_thuc, "DD/MM/YYYY"),
        so_lan_duoc_thi: dataExamDetail.so_lan_duoc_thi,
      });

      if (
        dataExamDetail.users_selected &&
        dataExamDetail.users_selected.length > 0
      ) {
        setUsersSelected([...dataExamDetail.users_selected]);
        setSelectedRowKeys([...dataExamDetail.users_selected]);
      }
      console.log([...dataExamDetail.users_selected]);



    }

    if (!isCheckOpenModal) {
      // Reset from khi tắt modal
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
      setTeamsSelected([]);
      setUsersSelected([]);
      setSelectedRowKeys([]);
      setData([]);
      form.resetFields();
    }
  }, [form, dataExamDetail, isCheckOpenModal]);

  // useEffect(() => {
  //   if (!data.length) return;

  //   let initSelected = [];

  //   // chọn tất cả user trong team đã được chọn
  //   // if (teamsSelected && teamsSelected.length > 0) {
  //   //   initSelected = [
  //   //     ...initSelected,
  //   //     ...data
  //   //       .filter((u) => teamsSelected.includes(u.fore_team__tenTeam))
  //   //       .map((u) => u.id),
  //   //   ];
  //   // }

  //   setSelectedRowKeys([...new Set(initSelected)]); // loại trùng
  // }, [data, usersSelected, teamsSelected]);

  // useEffect(() => {
  //   if (currentTeam.length > 0) {
  //     fetchDataUser({ idTeam: JSON.stringify(currentTeam) });
  //   }
  //   if (currentTeam.length === 0) {
  //     setData([]);
  //   }
  // }, [form.getFieldValue('')]);

  // Hàm duyệt dữ liệu để log theo rule
  useEffect(() => {

    const teamTick = [];
    const userTick = [];
    const teamMap = {};
    let notSelectedTeams = [];
    let notSelectedUsers = [];

    if (data == undefined) {
      return;
    }
    data.forEach((u) => {
      if (!teamMap[u.fore_team__id]) {
        teamMap[u.fore_team__id] = [];
      }
      teamMap[u.fore_team__id].push(u);
    });

    Object.entries(teamMap).forEach(([teamID, users]) => {
      const selectedUsers = users.filter((u) => selectedRowKeys.includes(u.id));
      if (selectedUsers.length === users.length && users.length > 0) {
        // TH chọn toàn bộ của 1 team
        teamTick.push(teamID);

        // lấy ds user của 1 team | vì chỉ lấy theo team
        users.forEach((u) => notSelectedUsers.push(u.id));
      } else if (selectedUsers.length === 0) {
        // TH bỏ chọn tất cả của 1 team
        notSelectedTeams.push(teamID);

        // lấy ds user đã bỏ chọn của 1 team
        users.forEach((u) => notSelectedUsers.push(u.id));
      } else {
        // TH tích chọn từng ô
        // DS user có chọn của 1 team
        selectedUsers.forEach((u) => userTick.push(u.id));

        // DS user không chọn của 1 team
        users
          .filter((u) => !selectedRowKeys.includes(u.id))
          .forEach((u) => notSelectedUsers.push(u.id));

        //
        if (selectedUsers.length !== 0) {
          // DS user có chọn nhưng không toàn team thì không xuất theo team
          notSelectedTeams.push(teamID);
        }
      }
    });

    // Loại bỏ các user/team uncheckbox trong teamsSelected và usersSelected
    const filterTeams = teamsSelected.filter(
      (team) => !notSelectedTeams.includes(team)
    );
    const filterUsers = usersSelected.filter(
      (user) => !notSelectedUsers.includes(user)
    );
    console.log([...new Set([...filterTeams, ...teamTick])]);
    console.log([...new Set([...filterUsers, ...userTick])]);


    setTeamsSelected([...new Set([...filterTeams, ...teamTick])]);
    setUsersSelected([...new Set([...filterUsers, ...userTick])]);
  }, [selectedRowKeys]); // mỗi khi tick/un-tick sẽ chạy lại

  // toggle select all users
  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedRowKeys([]);
    } else {
      setSelectedRowKeys(data.map((r) => r.id));
    }
  };

  // toggle one row
  const toggleSelectRow = (id) => {
    setSelectedRowKeys((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSearch = () => {
    // if (form.getFieldValue("loai_cau_hoi") == undefined) {
    //   openNotificationWithIcon("error", "Vui lòng chọn nhóm thi");
    //   return false;
    // }

    if ([undefined].includes(currentTeam.length === 0)) {
      openNotificationWithIcon("error", "Vui lòng chọn team");
      return false;
    }

    // if (selectedGroup.current != form.getFieldValue("loai_cau_hoi")) {
    //   setTeamsSelected([]);
    //   setUsersSelected([]);
    // }

    fetchDataUser({
      idTeam: JSON.stringify(currentTeam),
      // idGroup: form.getFieldValue("loai_cau_hoi"),
    });

  };

  const columns = getColumns({
    allSelected,
    someSelected,
    selectedRowKeys,
    form,
    toggleSelectRow,
    toggleSelectAll,
  });

  return (
    <Modal
      // title={!!dataExamDetail ? "Chỉnh sửa đợt thi" : "Tạo đợt thi"}
      title={
        !!dataExamDetail ? (
          <div
            style={{
              // display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Chỉnh sửa đợt thi</span>
            <Button
              type="link"
              icon={<QuestionCircleOutlined />}
              onClick={() => showDrawer()}
              style={{
                float: "right",
                marginRight: "25px",
                paddingBottom: "20px",
              }}
            ></Button>
          </div>
        ) : (
          <span>Tạo đợt thi</span>
        )
      }
      open={isCheckOpenModal}
      footer={false}
      width={800}
      className={"site-drawer-render-in-current-wrapper"}
      onCancel={handleCancelExam}
    >
      <Form
        form={form}
        name="basic"
        layout={"vertical"}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col span={7}>
            <Form.Item
              label="Mã đề thi"
              name="ma_de_thi"
              rules={[{ required: true }]}
            >
              <Input
                maxLength={100}
                disabled={!!dataExamDetail}
                placeholder="CB_202506_01"
              />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label="Nhóm thi"
              name="loai_cau_hoi"
              rules={[{ required: true }]}
            >
              <Select disabled={!!dataExamDetail}>
                {valueTypeQuestion.map((item, index) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.note} ({item.loai_cau_hoi})
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Ngày bắt đầu"
              name="ngay_bat_dau"
              rules={[{ required: true }]}
            >
              <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="Ngày kết thúc"
              name="ngay_ket_thuc"
              rules={[{ required: true }]}
            >
              <DatePicker format={"DD/MM/YYYY"} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Số câu hỏi"
              name="so_luong_cau_hoi"
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="25" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Số câu đạt"
              name="so_cau_dat"
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="22" />
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item
              label="Thời gian thi"
              name="thoi_gian_thi"
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="20 phút" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Số lần thi"
              name="so_lan_duoc_thi"
              rules={[{ required: true }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="3" />
            </Form.Item>
          </Col>
          <Divider style={{ marginTop: 0, marginBottom: "8px" }}>
            Danh sách tham gia đợt thi
          </Divider>

          <Col span={7}>
            <Form.Item
              label="Bộ phận"
              name="bophan"
              rules={[{ required: !!dataExamDetail ? false : true }]}
            >
              <TreeSelect {...tPropsConfig_BoPhan} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item
              label="Team"
              name="team"
              rules={[{ required: !!dataExamDetail ? false : true }]}
            >
              <TreeSelect {...tPropsConfig} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col
            span={2}
            style={{
              display: "flex",
              textAlign: "center",
              alignItems: "center",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              icon={<SearchOutlined />}
              style={{ marginLeft: 20 }}
              onClick={handleSearch}
              className="button-save-filter"
              size="small"
            />
          </Col>
          <Col span={24}>
            <Table
              bordered={true}
              className={"custom-table-hover style-6"}
              columns={columns}
              dataSource={data}
              pagination={false}
              size="small"
              scroll={{ y: 350 }}
            />
          </Col>
          <Col span={24}>
            <Form.Item
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "8px",
              }}
            >
              {!!dataExamDetail && (
                <>
                  <Button
                    type="link"
                    ghost
                    className="btn-download"
                    style={{ marginRight: 16 }}
                    onClick={fileDownloadExam}
                  >
                    Tải đợt thi
                  </Button>
                  <Popconfirm
                    title="Bạn có chắn chắn xóa đợt thi không ?"
                    onConfirm={handleDeleteExam}
                    okText="Xóa"
                    cancelText="Không xóa"
                  >
                    <Button type="primary" danger style={{ marginRight: 16 }}>
                      {" "}
                      Xóa đợt thi
                    </Button>
                  </Popconfirm>
                </>
              )}
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 16 }}
              >
                {!!dataExamDetail ? "Chỉnh sửa" : "Lưu"}
              </Button>
              <Button onClick={handleCancelExam}>Thoát</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Drawer
        title="Hướng dẫn sử dụng"
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={400}
        keyboard
        getContainer={false}
      >
        <p>
          <strong>1. Phạm vi ngày thi</strong>
        </p>
        <ul>
          <li>Ngày kết thúc không được nhỏ hơn ngày bắt đầu thi</li>
        </ul>
        <p>
          <strong>2. Xóa đợt thi</strong>
        </p>
        <ul>
          <li>
            Chỉ xóa khi không có nhân viên nào đã làm bài thi trong đợt đó
          </li>
        </ul>
      </Drawer>
    </Modal>
  );
};

export default ViemUpdateExam;
